module.exports = __webpack_public_path__ + "img/logo_kurazushi.43c5484f.svg";